export enum RouteNames {
    DOCUMENTATION = '/documentation',
    LOGIN = '/login',
    RESET_PASSWORD_REQUEST = '/resetPasswordRequest',
    RESET_PASSWORD_CONFIRM = '/resetPasswordConfirm',
    SETTINGS = '/settings',
    USERS_ACTIVATION = '/usersActivation',
    SET_ASSISTANT_SIMPLE = '/setassistanssimple',
    SIGN_UP = '/signup',
    SIGN_UP_CONFIRM = '/signUpConfirm',
    CHANGE_EMAIL_CONFIRM = '/changeEmailConfirm',
    DASHBOARD = '/',
    DOCUMENTS = '/documents',
    DICTIONARIES = '/dictionaries',
    REPORTS = '/reports',
    DASHBOARDS = '/dashboards',
    DASHBOARD_VIEW = '/dashboards/:id',
    DASHBOARD_LEGACY_VIEW = '/dashboards/:folder/:name',
    DOCUMENT = '/document/:id',
    DOCUMENT_SUPPORT_PREVIEW = '/support/document-preview/:sessionId',
    DOCUMENT_CREATE_ON_BASE = '/document/createOnBase/:baseDocId/:actId/:draftId?',
    DOCUMENT_CREATE_ON_BASE_TEMPLATE = '/document/createOnBase/:baseDocId/:actId/:templateId/:draftId?',
    DOCUMENT_CREATE_BY_ACTION = '/document/createByAction/:actId/:draftId?',
    DOCUMENT_CREATE_BY_ACTION_TEMPLATE = '/document/createByAction/:actId/:templateId/:draftId?',
    TASKS = '/tasks',
    SEARCH = '/search',
    NOTIFICATION = '/notification/:id?',
    ROLES = '/roles',
    RELEASENOTES = '/releasenotes',
    REDIRECTS_AND_REPLACEMENTS = '/redirects-and-replacements',
    SETTINGS_NOTIFICATIONS = '/settings/notifications',
    CUSTOMUSERSETTINGS = '/custom-user-settings/:id',
    ADFS_SAML_SSO_SIGN_IN_REDIRECT = '/sso/saml/redirect/signin',
    ADFS_SAML_SSO_SIGN_OUT_REDIRECT = '/sso/saml/redirect/signout',
    ADFS_SAML_SSO_SIGN_IN = '/sso/saml/signin',
    ADMINISTRATIONS_DYNGROUPS = '/administrations/dyngroups',
}
